<template>
  <div>
    <div>
      <label>
        <gmap-autocomplete @place_changed="initMarker"></gmap-autocomplete>
        <v-btn @click="addLocationMarker">Add</v-btn>
      </label>
      <br/>
 
    </div>
    <br>
    <gmap-map
        :zoom="15"    
        :center="center"
        style="width:100%;  height: 600px;"
      >
      <gmap-marker
        :key="index"
        v-for="(m, index) in locationMarkers"
        :position="m.position"
        @click="center=m.position"
      ></gmap-marker>
    </gmap-map>
  </div>
</template>
<script>
import axios from "axios";

export default {
  name: "DeviceList",
  data() {
    return {
      loading: true,
      headers: [
        { text: "Device", value: "name" },
        { text: "Code Name", value: "codename" },
        { text: "URL", value: "kosherUrl" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      items: [],
      center: { 
        lat: 39.7837304,
        lng: -100.4458825
      },
      locationMarkers: [],
      locPlaces: [],
      existingPlace: null
    };
  },
  methods: {
    getItems() {
      this.loading = true;
      axios.get(`https://api.safetelecom.net/api/devices`).then((response) => {
        this.items = response.data;
        this.loading = false;
      });
    },
    refreshPage() {
      this.items = [];
      this.getItems();
    },
    initMarker(loc) {
      this.existingPlace = loc;
    },
    addLocationMarker() {
      if (this.existingPlace) {
        const marker = {
          lat: this.existingPlace.geometry.location.lat(),
          lng: this.existingPlace.geometry.location.lng()
        };
        this.locationMarkers.push({ position: marker });
        this.locPlaces.push(this.existingPlace);
        this.center = marker;
        this.existingPlace = null;
      }
    },
    locateGeoLocation: function() {
      navigator.geolocation.getCurrentPosition(res => {
        this.center = {
          lat: res.coords.latitude,
          lng: res.coords.longitude
        };
      });
    }
  },
  mounted() {
    this.locateGeoLocation();
  },
  created() {
    this.getItems();
  },
};
</script>
